import React from "react";
import {t} from "../../../helpers/translator";
import CountDownComponent from "../countDownClock";

export default function dmsRegister () {
    return <>
        <div className="title-popup-page-m-dms">
            <p className='auth-popup-title'>{t("Registration")}</p>
            {
                this.props.popupParams && this.props.popupParams.disable ? null
                    : <button className="popup-closed-b" onClick={this.registerPopupForDms()}/>
            }
        </div>
        <div className="ticket-results-view-p">
            {
                Object.getOwnPropertyNames(this.props.isCardRegistered).length === 0
                    ? <h3>{t("Please input your card for registration")}</h3>
                    : !this.props.isCardRegistered.bool && <h3>{t("This card already exist")}</h3>
            }
            {this.props.isCardRegistered && <i className="icon-rfid-card" />}
            <div className="buttons-view-w-t">
                <div className="separator-box-buttons-m-wrap card-register-buttons">
                    {
                        this.props.isCardRegistered
                            ? this.props.isCardRegistered.bool === true &&
                            <div className="separator-box-buttons-m">
                                <button className="button-view-normal-m"
                                        onClick={this.props.openPopup("dmsRegisterFields")}>
                                    {t("Register")}
                                </button>
                            </div>
                            : null
                    }
                    <div className="separator-box-buttons-m">
                        <button className="button-view-normal-m trans-m"
                                onClick={this.registerPopupForDms()}>
                            {t("Cancel")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </>;
}
